import Question from './SimpleQuestion/Question';
import { QuestionInterface, SideBarInterface } from '../../lib/type';
import { layoutContext } from '../LeaderAssesssment';
import { useContext, useEffect, useState, useRef } from 'react';
import './Questions.scss';
import QuestionTable from './QuestionTable/QuestionTable';
import MultipleChoiceQuestion from './SimpleQuestion/MutipleChoiceQuestion';
import DropQuestion from './DropQuestion/DropQuestion';

interface questionsProps {
  contents: QuestionInterface[];
  sideBar: SideBarInterface;
}

const Questions = (questionsProps: questionsProps) => {
  const { contents, sideBar } = questionsProps;
  const { currentQuestion, selectedAnswers } = useContext(layoutContext);
  const [mobile, setMobile] = useState(false);
  const targetDivRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (window.innerWidth <= 500) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  useEffect(() => {
    if (targetDivRef.current) {
      targetDivRef.current.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [currentQuestion]);

  return (
    <div
      className="leadership-assesssment__questions bx--row"
      ref={targetDivRef}
    >
      <div
        className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4"
        style={{ padding: 0 }}
      >
        {contents.map((question: QuestionInterface) => {
          if (question.questionNumber === currentQuestion) {
            if (question.type === 'regular') {
              return (
                <Question
                  contents={question}
                  totalOfQuestions={contents.length}
                  qNextBtn={sideBar.qNextBtn}
                  lastQuestion={contents.length}
                />
              );
            } else if (question.type === 'table') {
              return !mobile ? (
                <QuestionTable
                  contents={question}
                  totalOfQuestions={contents.length + 1}
                  qNextBtn={sideBar.qNextBtn}
                />
              ) : (
                <DropQuestion
                  contents={question}
                  totalOfQuestions={contents.length + 1}
                  qNextBtn={sideBar.qNextBtn}
                />
              );
            } else if (question.type === 'multiOption') {
              return (
                <MultipleChoiceQuestion
                  contents={question}
                  totalOfQuestions={contents.length}
                  qNextBtn={sideBar.qNextBtn}
                  lastQuestion={contents.length}
                />
              );
            } else {
              return !mobile ? (
                <QuestionTable
                  contents={{
                    id: question.id,
                    type: question.type,
                    title: question.title,
                    subTitle: question.subTitle,
                    options: selectedAnswers,
                    degree: question.degree,
                    questionNumber: question.questionNumber,
                  }}
                  totalOfQuestions={contents.length + 1}
                  qNextBtn={sideBar.qNextBtn}
                />
              ) : (
                <DropQuestion
                  contents={{
                    id: question.id,
                    type: question.type,
                    title: question.title,
                    subTitle: question.subTitle,
                    options: selectedAnswers,
                    degree: question.degree,
                    questionNumber: question.questionNumber,
                  }}
                  totalOfQuestions={contents.length + 1}
                  qNextBtn={sideBar.qNextBtn}
                />
              );
            }
          }
        })}
      </div>
    </div>
  );
};

export default Questions;
